/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Output_Truncated_ShortInputs */



/**
* | output |
* | --- |
* | "cut off" |
*
* @param {Chat_Output_Truncated_ShortInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_output_truncated_short = /** @type {((inputs?: Chat_Output_Truncated_ShortInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Output_Truncated_ShortInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("abgeschnitten")
	return /** @type {LocalizedString} */ ("cut off")
});